import './TradeDetailsPage.css';
import { IonButton, IonButtons, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonNote, IonText, IonToolbar, IonThumbnail } from "@ionic/react";
import { closeOutline} from "ionicons/icons";
import moment from "moment";
import { Asset, DisplayableOperation } from "../../types/types";
import { useTranslation } from 'react-i18next';
import { PropsWithChildren, useEffect, useState } from 'react';
import AppHeader from '../../components/AppHeader/AppHeader';
import { Browser } from "@capacitor/browser";
import { App, BackButtonListenerEvent } from '@capacitor/app'
import { useAppSelector } from '../../services/redux/hook';


interface TradeDetailsProps extends PropsWithChildren {

  closeAction: ()=>void;
  operation: DisplayableOperation;
  asset: Asset

}

const TradeDetailsPage: React.FC<TradeDetailsProps> = (props) => {

  // dealing with android back button and modals
  // App.addListener('backButton', (ev: BackButtonListenerEvent) => {
  //   props.closeAction()
  // });

  useEffect(() => {
    let backButtonListener:any;

    const setupBackButtonListener = async () => {
        backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
            props.closeAction();
        });
    };

    setupBackButtonListener();

    // Cleanup function
    return () => {
        backButtonListener?.remove();
    };
}, [props.closeAction]);

  const { t, i18n } = useTranslation();
  const stellarExperUIURL = `${import.meta.env.VITE_STELLAR_EXPERT_UI_URL}`;
  const [priceLabel, setPriceLabel] = useState('');
  const [boughtLabel, setBoughtLabel] = useState('');
  const [soldLabel, setSoldLabel] = useState('');
  const supportedAssets = useAppSelector((state) => state.supportedAssets.supportedAssets);


  


  const fromAsset = supportedAssets.filter((asset: Asset) => {
    return (props.operation.sourceToken?.code === asset.display_code)
  })

  const toAsset = supportedAssets.filter((asset: Asset) => {
    return (props.operation.token?.code === asset.display_code)
  })

  const goToTransactionExplorer = async (transactionId: string) => {

    await Browser.open({ url: `${stellarExperUIURL}/tx/${transactionId}` });

  }

  useEffect(() => {

    let priceLabel: string;
    let boughtLabel: string;
    let soldLabel: string;

    const amount = props.operation.amount;
    const tokenCode = props.operation.token.code;
    const sourceTokenCode = props.operation.sourceToken?.code;
    const sourceAmount = props.operation.sourceAmount;
    const asset = props.asset
    

    // bought
    if (tokenCode === asset.display_code) {

      if (sourceAmount) {

        const rateAmount = parseFloat(sourceAmount.toString()) / parseFloat(amount.toString());

        priceLabel = `1 ${asset.display_code} = ${rateAmount.toFixed(fromAsset[0].decimal_places)} ${sourceTokenCode}`
        setPriceLabel(priceLabel);

        boughtLabel = `${parseFloat(amount.toString()).toFixed(toAsset[0].decimal_places)} ${tokenCode}`;
        setBoughtLabel(boughtLabel);

        soldLabel = `${parseFloat(sourceAmount.toString()).toFixed(fromAsset[0].decimal_places)} ${sourceTokenCode}`;
        setSoldLabel(soldLabel);

      }

    }

    // sold
    if (sourceTokenCode === asset.display_code) {

      if (sourceAmount) {

        const rateAmount = parseFloat(amount.toString()) / parseFloat(sourceAmount.toString());

        priceLabel = `1 ${asset.display_code} = ${rateAmount.toFixed(toAsset[0].decimal_places)} ${tokenCode}`
        setPriceLabel(priceLabel);

        soldLabel = `${parseFloat(sourceAmount.toString()).toFixed(fromAsset[0].decimal_places)} ${sourceTokenCode}`;
        setSoldLabel(soldLabel);

        boughtLabel = `${parseFloat(amount.toString()).toFixed(toAsset[0].decimal_places)} ${tokenCode}`;
        setBoughtLabel(boughtLabel);

      }

    }

  }, [])


  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar >
          <IonButtons slot="start">
            <IonButton color='primary' onClick={() => { props.closeAction() }}>
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
          {/* <IonButtons slot="primary">
            <IonButton onClick={() => { goToTransactionExplorer(props.operation.transactionId) }}>
              <IonIcon slot="icon-only" icon={openOutline} color="danger" />
            </IonButton>
          </IonButtons> */}
        </IonToolbar>
      </IonHeader>

      <IonContent>

        {
          props.operation.token.code === props.asset.display_code ?
            <AppHeader title={`+${parseFloat(props.operation.amount.toString()).toFixed(props.asset.decimal_places)} ${props.operation.token.code}`}></AppHeader> :
            <AppHeader title={`-${props.operation.sourceAmount ? parseFloat(props.operation.sourceAmount?.toString()).toFixed(props.asset.decimal_places) : '0'} ${props.operation.sourceToken?.code}`}></AppHeader>
        }

        <IonItem lines='none' className='tradeDetails_Item'>
          <IonLabel slot='start'>
            <IonText className="ion-text-wrap">
              <h5>
                {
                  props.operation.token.code === props.asset.display_code ?
                    `${t('trade.details.bought')} ${props.asset.display_code} ${t('trade.details.bought-WITH')} ${props.operation.sourceToken?.code}`
                    :
                    `${t('trade.details.sold')} ${props.asset.display_code} ${t('trade.details.sold-FOR')} ${props.operation.token?.code}`
                }

              </h5>
            </IonText>
            <IonNote className="tradeDetailsPage_IonNote">
              {moment.unix(props.operation.timestamp).format("D MMM YYYY,h:mm")}
            </IonNote>
          </IonLabel>
          <IonThumbnail className="paymentDetails_Thumbnail" slot="end">
            <img src={props.asset.icon} />
          </IonThumbnail>
        </IonItem>


        <IonCard className='ion-padding'>

          <IonItem lines='none' >
            <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {t('trade.details.status')}
            </IonNote>
            <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {t('trade.details.status-LABEL-COMPLETED')}
            </IonNote>
          </IonItem>

          <IonItem lines='none'>
            <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {t('trade.details.price')}
            </IonNote>
            <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {priceLabel}
            </IonNote>
          </IonItem>

          <IonItem lines='none' >
            <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {t('trade.details.bought')}
            </IonNote>
            <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {boughtLabel}
            </IonNote>
          </IonItem>

          <IonItem lines='none' >
            <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {t('trade.details.sold')}
            </IonNote>
            <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
              {soldLabel}
            </IonNote>
          </IonItem>

        </IonCard>

      </IonContent>


    </>

  );
};

export default TradeDetailsPage;